import * as S from './styles';
import { useCart } from '@/hooks';
import { colors } from '@/constants';
import { useMemo, useRef } from 'react';
import { packingTypes } from '@/shared';
import { ProductProps, PackagesTypesProps, PackagingProductProps } from '@/types';

interface Product {
  size?: number;
  showQtd?: boolean;
  product: ProductProps;
  pack: PackagesTypesProps;
  packQty: number;
  setPackage: (val: PackagesTypesProps) => void;
  setPackQuantity: (val: number) => void;
  autoSelectFirst?: boolean;
  canDisablePack?: boolean;
  fullBorder?: boolean;
}

const RenderPackaging = ({
  pack,
  size,
  product,
  packQty,
  setPackage,
  setPackQuantity,
  canDisablePack = true,
  fullBorder = false,
}: Product) => {
  const { getLimit } = useCart();

  const list = useMemo(() => {
    const embs = product?.EMBALAGEM ? [...product.EMBALAGEM] : [];
    if (!embs.length) return [{ SG_EMBALAGEM: 'UN' }];

    const orderedList = embs.sort((a, b) => {
      const aQtd = (a.QTD_MULTIPLO_VENDA || 1) * (a.QTD_EMBALAGEM || 1);
      const bQty = (b.QTD_MULTIPLO_VENDA || 1) * (b.QTD_EMBALAGEM || 1);
      return aQtd < bQty ? 1 : -1;
    });
    return orderedList;
  }, [product.EMBALAGEM]) as PackagingProductProps[];

  const limit = getLimit(product?.COD_PRODUTO);

  return (
    <>
      <S.Row>
        {/* Rever esse map */}
        {list.map((embalagem) => {
          const packing = packingTypes?.[embalagem?.SG_EMBALAGEM];

          const qty = embalagem?.QTD_MULTIPLO_VENDA > 1 ? embalagem?.QTD_MULTIPLO_VENDA : embalagem?.QTD_EMBALAGEM;

          const isActive =
            pack === 'PK'
              ? embalagem?.QTD_MULTIPLO_VENDA > 1 && embalagem?.QTD_MULTIPLO_VENDA === packQty && pack === embalagem?.SG_EMBALAGEM
              : embalagem?.SG_EMBALAGEM === pack && embalagem?.QTD_EMBALAGEM === packQty;
          const rawPrecos: any = product?.PRECO || {};
          const list: any[] = Array.isArray(rawPrecos) ? rawPrecos : Object.values(rawPrecos || {});
          const hasPrice = list.find((p) => p?.SG_EMBALAGEM === packing?.shortName);
          const isDisabled = canDisablePack && (limit < qty || !hasPrice);

          return (
            <S.BoxEmbalagem
              size={size}
              $fullBorder={fullBorder}
              $isactive={isActive}
              $unityPack={list.length === 1}
              onClick={() => {
                if (isDisabled) return;

                setPackage(packing?.shortName);
                setPackQuantity(qty);
              }}
              key={`pack-${product.COD_PRODUTO}-${packing?.shortName}-${qty}`}
              data-test={`pack-${product.COD_PRODUTO}-${packing?.shortName}-${qty}`}
            >
              <S.PackImage src={packing?.icon} alt="" />
              {isActive && <S.CheckFill size={24} color={colors.alert.green110} />}

              <S.BoxLabel>
                <S.BoxQtdEmbalagem>
                  <S.QtdEmbalagem>{qty}/un</S.QtdEmbalagem>
                </S.BoxQtdEmbalagem>
              </S.BoxLabel>
            </S.BoxEmbalagem>
          );
        })}
      </S.Row>
    </>
  );
};

export default RenderPackaging;
